
import { SiriusBaseComponent } from 'sirius-framework';
import { Component, Input } from '@angular/core';
import { CommonService } from '../../service/shared.service';
import { ProcessAction, ProcessStateList, ProcessDetailActionRequest } from '../../models/process.model';

@Component({
    selector: 'process-action',
    templateUrl: './process-action.component.html',
    styleUrls: ['./process-action.component.css']
})
export class ProcessActionComponent extends SiriusBaseComponent<any> {
    @Input('ProcessRef') processRef: string;
    @Input('IsLive') isLive: boolean;
    processActionResult: ProcessAction = null;
    noResult: boolean = false;
    processActionResultList: ProcessStateList[] = [];
    mainSteps: boolean[] = [false, false, false, false, false, false];
    /* String Resource */
    processAction_Time: string;
    processAction_Status: string;
    processAction_ProcessStatus10: string;
    processAction_ProcessStatus20: string;
    processAction_ProcessStatus60: string;
    processAction_ProcessStatus30: string;
    processAction_ProcessStatus50: string;
    processAction_ProcessStatus71: string;
    constructor(private commonService: CommonService) {
        super();
    }
    OnInit() {
        this.setStringResource();
        if (this.commonService.selectedProcessAction != null) {
            if (this.commonService.selectedProcessAction.processRef == this.processRef) {
                this.processActionResult = this.commonService.selectedProcessAction.data as ProcessAction;
                this.processActionResultList = this.processActionResult.ProcessStateList;
                if (this.processActionResultList != null && this.processActionResultList.length > 0) {
                    this.mainSteps[0] = this.processActionResultList.some(x => x.ProcessStatus == "10");
                    this.mainSteps[1] = this.processActionResultList.some(x => x.ProcessStatus == "20");
                    this.mainSteps[2] = this.processActionResultList.some(x => x.ProcessStatus == "60");
                    this.mainSteps[3] = this.processActionResultList.some(x => x.ProcessStatus == "30");
                    this.mainSteps[4] = this.processActionResultList.some(x => x.ProcessStatus == "50");
                    this.mainSteps[5] = this.processActionResultList.some(x => x.ProcessStatus == "71");
                }
            }
            else {
                this.commonService.selectedProcessAction = null;
                this.callProcessActionService();
            }
        }
        else {
            this.callProcessActionService();
        }           
    }   
    setStringResource() {
        this.processAction_Time = this.resourceService.getResource("processAction_Time");
        this.processAction_Status = this.resourceService.getResource("processAction_Status");
        this.processAction_ProcessStatus10 = this.resourceService.getResource("processAction_ProcessStatus10");
        this.processAction_ProcessStatus20 = this.resourceService.getResource("processAction_ProcessStatus20");
        this.processAction_ProcessStatus60 = this.resourceService.getResource("processAction_ProcessStatus60");
        this.processAction_ProcessStatus30 = this.resourceService.getResource("processAction_ProcessStatus30");
        this.processAction_ProcessStatus50 = this.resourceService.getResource("processAction_ProcessStatus50");
        this.processAction_ProcessStatus71 = this.resourceService.getResource("processAction_ProcessStatus71");
    }
    callProcessActionService() {
        var processDetailActionRequest: ProcessDetailActionRequest = {
            ProcessRef: this.processRef,
            IsLive: this.isLive
        }
        var promise = this.commonService.GetProcessAction(this.dataService, processDetailActionRequest);
        promise.then((result) => {
            if (result != null) {
                this.processActionResult = result as ProcessAction;
                if (!this.processActionResult.IsThereError) {
                    this.processActionResultList = this.processActionResult.ProcessStateList;
                    this.commonService.selectedProcessAction = { processRef: this.processRef, data: this.processActionResult };
                    if (this.processActionResultList != null && this.processActionResultList.length > 0) {
                        this.mainSteps[0] = this.processActionResultList.some(x => x.ProcessStatus == "10");
                        this.mainSteps[1] = this.processActionResultList.some(x => x.ProcessStatus == "20");
                        this.mainSteps[2] = this.processActionResultList.some(x => x.ProcessStatus == "60");
                        this.mainSteps[3] = this.processActionResultList.some(x => x.ProcessStatus == "30");
                        this.mainSteps[4] = this.processActionResultList.some(x => x.ProcessStatus == "50");
                        this.mainSteps[5] = this.processActionResultList.some(x => x.ProcessStatus == "71");
                    }
                    this.noResult = false;
                }
                else {
                    this.processActionResult = null;
                    this.noResult = true;
                }
            }
        });
    }
    GetDateTimeText(date: string, time: string) {
        let dateText = "";
        let timeText = "";
        if (date != null && date.length == 8)
            dateText = date.substr(6, 2) + '.' + date.substr(4, 2) + '.' + date.substr(0, 4);
        if (time != null && time.length == 6)
            timeText = time.substr(0, 2) + ":" + time.substr(2, 2);
        return dateText + " " + timeText;
    }
}
